import http from "./http";

export const getGameProvider = () => {
  return http.get(`/api/orderInformation/getGameProvider`);
};
